import React from 'react';
import T from 'prop-types';

import MetricOverview from './MetricOverview';
import MarketShareChart from './MarketShareChart';
import SectionError from '../SectionError';
import SimpleCard from '../../../../components/Card/SimpleCard';

const emptyArray = [];

const MarketOverviewCard = ({ marketOverview, apps = emptyArray, isAppsPending }) => {
  const { data, settings } = marketOverview;

  if (settings.error) return <SectionError />;

  return (
    <SimpleCard contentDisableGutters actionsLeft={<div className="highcharts-watermark" />}>
      <MetricOverview data={data} isPending={settings.pending} />
      <MarketShareChart
        apps={apps}
        series={data.time_series?.market_share}
        isPending={isAppsPending || settings.pending}
      />
    </SimpleCard>
  );
};

MarketOverviewCard.propTypes = {
  marketOverview: T.shape({
    data: T.object.isRequired,
    settings: T.object.isRequired,
  }).isRequired,
  apps: T.array,
  isAppsPending: T.bool.isRequired,
};

export default MarketOverviewCard;
